import React, { useState, useEffect } from 'react'
import Tabs from '../../templates/Tabs'
import { useDispatch, useSelector } from 'react-redux';
import { LOADING } from '../../../redux_store/actionTypes';
import { getAllRefunds } from '../../../redux_store/refunds/refunds_thunk';
import LoadingModal from '../../templates/modals/LoadingModal';
import { CREDIT, PROMO } from '../../../redux_store/asyncConfig';
import RefundPromoTable from './RefundPromoTable';
import RefundCreditTable from './RefundCreditTable';
import { clearRefundState } from '../../../redux_store/refunds/refunds_slice';

const RefundsPage = () => {
  const dispatch = useDispatch();
  const [tabSelected, setTabSelected] = useState('Promo Refunds');
  const { status, refunds } = useSelector((state)=>state.refund);

  useEffect(()=>{
    dispatch(clearRefundState())
    dispatch(getAllRefunds(getFormatted(tabSelected)));
    // eslint-disable-next-line
  }, []);

  const handleTabSelection = (e) => {
    const tab = e.target.innerText;
    dispatch(clearRefundState())
    dispatch(getAllRefunds(getFormatted(tab)));
    setTabSelected(tab);
  }

  const getFormatted = (tab) => {
    if(tab === 'Promo Refunds')
      return PROMO
    else if(tab === 'Credit Refunds')
      return CREDIT
  }

  return (
    <div>
      {status === LOADING && <LoadingModal message={'Loading data...'} />}
      <Tabs
        active={tabSelected}
        heading={['Promo Refunds', 'Credit Refunds']} 
        onTabSelect={handleTabSelection}
      />
      {tabSelected === 'Promo Refunds' ? 
      <RefundPromoTable 
        promos={refunds} 
      />: <RefundCreditTable 
        credit={refunds}        
      />}
    </div>
  )
}

export default RefundsPage